import { render } from "./ScheduleView.vue?vue&type=template&id=b2543bb2&lang=true"
import script from "./ScheduleView.vue?vue&type=script&lang=js"
export * from "./ScheduleView.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/kv-cloud-pbx/kv-cloud-pbx/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__